import React, { useState } from 'react';
import { FaTwitter, FaLinkedin, FaGlobe, FaEnvelope } from 'react-icons/fa';
import ReCAPTCHA from 'react-google-recaptcha';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <h1>عني</h1>
      <p>مرحبًا! أنا إبراهيم، مطور ومدون.</p>

      <div className="social-grid">
        <a href="https://x.com/blog_iburtum" target="_blank" rel="noopener noreferrer">
          <FaTwitter className="social-icon" />
          <span>X (Twitter)</span>
        </a>

        <a href="https://www.linkedin.com/in/ibrahim-hamad-almuneef-8a890b28a/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin className="social-icon" />
          <span>LinkedIn</span>
        </a>

        <a href="https://iburtum.xyz" target="_blank" rel="noopener noreferrer">
          <FaGlobe className="social-icon" />
          <span>الموقع الإلكتروني</span>
        </a>

        <a href="mailto:support@iburtum.xyz">
          <FaEnvelope className="social-icon" />
          <span>البريد الإلكتروني</span>
        </a>
      </div>

      <ContactForm />
    </div>
  );
};

const ContactForm = () => {
  const [result, setResult] = useState("");
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!recaptchaValue) {
      setResult("يرجى التحقق من أنك لست روبوتًا.");
      return;
    }

    setResult("جارٍ الإرسال...");
    const formData = new FormData(event.target);

    const response = await fetch("https://getform.io/f/bolmlwza", { 
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      setResult("تم إرسال النموذج بنجاح");
      event.target.reset();
      setRecaptchaValue(null);
    } else {
      setResult("حدث خطأ أثناء الإرسال. حاول مرة أخرى.");
    }
  };

  return (
    <div className="contact-form">
      <h2>اتصل بي</h2>
      <form action="https://getform.io/f/bolmlwza" method="POST" encType="multipart/form-data" onSubmit={onSubmit}>
        <div className="form-group">
          <input type="text" name="name" placeholder="الاسم" required />
        </div>

        <div className="form-group">
          <input type="email" name="email" placeholder="البريد الإلكتروني" required />
        </div>

        <div className="form-group">
          <textarea name="message" placeholder="الرسالة" required rows="5"></textarea>
        </div>

        {/* File Upload */}
        <div className="form-group">
          <input type="file" name="file" />
        </div>

        {/* Google reCAPTCHA */}
        <div className="form-group">
          <ReCAPTCHA
            sitekey="6LelR9kqAAAAADn0Q4SqhrX4dFP9K4lXDQKci0Zx" // Replace with your reCAPTCHA site key
            onChange={(value) => setRecaptchaValue(value)}
          />
        </div>

        <button type="submit">إرسال الرسالة</button>
      </form>
      <span className="result-message">{result}</span>
    </div>
  );
};

export default About;
